import React from "react";

import UploadArquivosCanal from "../UploadArquivos";
import { CANAL_EMBARCADOR } from "../UploadArquivos/canais";

// A tela em si vive em ../UploadArquivos (PO1-2717): um componente para os dois
// canais. Este arquivo existe só para a rota do embarcador não mudar de import.
// Componente nomeado de módulo (não arrow inline na rota) para a identidade
// ficar estável entre renders.
export default function UploadFilesShipper() {
  return <UploadArquivosCanal canal={CANAL_EMBARCADOR} />;
}
